function createSafeSlug(input = '') {
  return input.replace(/[^a-z0-9 %-]+/gi, '');
}

export default createSafeSlug;
